import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./ContactWrapper.scss";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import { addNewContact } from "../../../services/userService";
import { toast } from "react-toastify";
class ContactWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      whatsapp: "",
      message: "",
      errors: {},
    };
  }
  componentDidMount() {}
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handlePhoneChange = (value) => {
    this.setState({ whatsapp: value || "" });
  };
  validateForm = () => {
    const { name, email, whatsapp, message } = this.state;

    const phoneRegexVN =
      /^(?:\+84|0)(3[2-9]|5[6|8|9]|7[0|6-9]|8[1-5]|9[0-9])[0-9]{7}$/;

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const errors = {
      ...(name.trim() ? {} : { name: "Vui lòng nhập tên của bản" }),
      ...(message.trim() ? {} : { message: "Vui lòng nhập lời nhắn của bạn" }),
      ...(!phoneRegexVN.test(whatsapp)
        ? {
            whatsapp:
              "Số điện thoại Việt Nam không hợp lệ. Vui lòng dùng đầu số +84 hoặc 0, theo sau là 9 chữ số.",
          }
        : {}),
      ...(!emailRegex.test(email)
        ? {
            email: "Email có định dạng hợp lệ là: tên@domain.com.",
          }
        : {}),
    };

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async () => {
    const { whatsapp, email, name, message } = this.state;

    const normalizedPhone = whatsapp.replace(/^\+84/, "0");

    this.setState({ isSubmitted: true });

    const isValid = this.validateForm();

    if (isValid) {
      const payload = {
        name: this.state.name,
        email: email,
        whatsapp: normalizedPhone,
        message: this.state.message,
      };
      try {
        const res = await addNewContact(payload);

        if (res && res.code === 200) {
          toast.success("Gửi lời nhắn thành công", {
            autoClose: 2000,
            position: "top-right",
          });
          this.props.history.push("/");
        } else {
          toast.error("Gửi lời nhắn thất bại. Vui lòng thử lại.");
        }
      } catch (err) {
        console.error("Submit failed:", err);
        toast.error("Lỗi kết nối đến máy chủ.");
      }
    }
  };
  render() {
    const { intl } = this.props;
    return (
      <section className="contact contact-wrapper" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="section-title">
                <h2 className="title">
                  <FormattedMessage id="contact.a1" />
                </h2>
                <p>
                  <FormattedMessage id="contact.a2" />
                  <FormattedMessage id="contact.a3" />
                  <FormattedMessage id="contact.a4" />
                </p>
              </div>
              <div className="address">
                <h4 className="title">
                  <FormattedMessage id="contact.a5" />
                </h4>
                <div className="list">
                  <p>
                    <a href="tel:0925227229" style={{ color: "white" }}>
                      <i className="fas fa-phone"></i>
                      <FormattedMessage id="contact.a6" />
                    </a>
                  </p>
                  <p>
                    <i className="fas fa-envelope"></i>
                    <FormattedMessage id="contact.a7" />
                  </p>
                  <p>
                    <i className="fas fa-map-marker-alt"></i>
                    <FormattedMessage id="contact.a7_1" />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="contact-form-wrapper">
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className={`input-field borderd ${
                        this.state.errors.name ? "has-error" : ""
                      }`}
                      id="name"
                      name="name"
                      placeholder={intl.formatMessage({ id: "contact.a9" })}
                      value={this.state.name}
                      onChange={this.handleChange}
                      required
                    />
                    {this.state.errors.name && (
                      <div className="error-text">{this.state.errors.name}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      className={`input-field borderd ${
                        this.state.errors.email ? "has-error" : ""
                      }`}
                      id="email"
                      name="email"
                      placeholder={intl.formatMessage({ id: "contact.a10" })}
                      value={this.state.email}
                      onChange={this.handleChange}
                      required
                    />
                    {this.state.errors.email && (
                      <div className="error-text">
                        {this.state.errors.email}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <PhoneInput
                      className={`input-field borderd whatapp ${
                        this.state.errors.whatsapp ? "has-error" : ""
                      }`}
                      international
                      defaultCountry="VN"
                      value={this.state.whatsapp}
                      onChange={this.handlePhoneChange}
                      placeholder={intl.formatMessage({ id: "contact.a11" })}
                      required
                    />
                    {this.state.errors.whatsapp && (
                      <div className="error-text">
                        {this.state.errors.whatsapp}
                      </div>
                    )}
                  </div>
                  <div className="col-12">
                    <textarea
                      className={`input-field borderd textarea ${
                        this.state.errors.message ? "has-error" : ""
                      }`}
                      rows="3"
                      id="message"
                      name="message"
                      placeholder={intl.formatMessage({ id: "contact.a12" })}
                      value={this.state.message}
                      onChange={this.handleChange}
                      required
                    ></textarea>
                    {this.state.errors.message && (
                      <div className="error-text">
                        {this.state.errors.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      className="mybtn1"
                      style={{ width: "100%" }}
                      onClick={this.handleSubmit}
                    >
                      <span id="btnText">
                        <FormattedMessage id="contact.a8" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(ContactWrapper))
);
